(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alp-announcebar-flash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });

    // 获取元素高度并设置为CSS变量
    function setFlashBarHeight() {
      const element = document.querySelector('.alp-announcement-bar-flash-section');
      if (element) {
        const height = element.offsetHeight; // 或者使用 getBoundingClientRect().height
        document.documentElement.style.setProperty('--flash-bar-height', height);
      }
    }

    // 初始设置
    setFlashBarHeight();
    // 监听窗口大小变化（如果需要响应式）
    window.addEventListener('resize', setFlashBarHeight);

    // 如果内容可能动态变化，可以添加MutationObserver
    const observer = new MutationObserver(setFlashBarHeight);
    const targetElement = document.querySelector('.alp-announcement-bar-flash-section');
    if (targetElement) {
      observer.observe(targetElement, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      autoHeight: true,
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      autoHeight: true,
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      autoHeight: true,
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-base-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class BaseSection extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('base-section', BaseSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpArticles extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('[data-cp-articles-swiper]');
        if (!this.swiperEl || typeof Swiper === 'undefined') return;
        if (this.swiper && !this.swiper.destroyed) return;

        this.navEl = this.querySelector('[data-cp-articles-nav]');
        this.scrollbarEl = this.querySelector('[data-cp-articles-scrollbar]');
        this.updateOverflowState = this.updateOverflowState.bind(this);
        this.onResize = this.onResize.bind(this);

        const layout = this.getLayout();
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: layout.slidesPerView,
          spaceBetween: layout.spaceBetween,
          watchOverflow: true,
          resizeObserver: true,
          pagination: {
            el: this.querySelector('.pagination-cp-articles'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          scrollbar: {
            el: this.scrollbarEl,
            draggable: true,
            hide: false,
          },
          on: {
            init: this.updateOverflowState,
            resize: this.updateOverflowState,
            slidesLengthChange: this.updateOverflowState,
            update: this.updateOverflowState,
          },
        });

        window.addEventListener('resize', this.onResize);
        requestAnimationFrame(() => {
          this.applyLayout(true);
          if (this.swiper && this.swiper.el && this.swiper.el.offsetWidth === 0) {
            requestAnimationFrame(() => this.applyLayout(true));
          }
        });
      }

      getLayout() {
        const width = window.innerWidth;
        if (width >= 1024) return { slidesPerView: 3, spaceBetween: 24 };
        if (width >= 768) return { slidesPerView: 2.2, spaceBetween: 20 };
        return { slidesPerView: 1.1, spaceBetween: 16 };
      }

      onResize() {
        this.applyLayout();
      }

      applyLayout(forceUpdate) {
        const swiper = this.swiper;
        if (!this.isConnected || !swiper || swiper.destroyed || !swiper.params) return;

        const layout = this.getLayout();
        const changed =
          swiper.params.slidesPerView !== layout.slidesPerView ||
          swiper.params.spaceBetween !== layout.spaceBetween;

        if (changed) {
          swiper.params.slidesPerView = layout.slidesPerView;
          swiper.params.spaceBetween = layout.spaceBetween;
          swiper.update();
          return;
        }

        if (forceUpdate && swiper.el && swiper.el.offsetWidth > 0) {
          swiper.update();
        }
      }

      updateOverflowState(swiperInstance) {
        if (!this.isConnected) return;

        const swiper =
          swiperInstance && swiperInstance.params && !swiperInstance.destroyed ? swiperInstance : this.swiper;
        if (!swiper || swiper.destroyed || !swiper.params || !swiper.slides) return;

        const slidesPerView = swiper.params.slidesPerView;
        if (slidesPerView == null) return;

        const visibleCount = slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Number(slidesPerView);
        const isOverflow = swiper.slides.length > visibleCount + 0.001;
        this.classList.toggle('is-overflow', isOverflow);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        const swiper = this.swiper;
        this.swiper = null;
        if (!swiper || swiper.destroyed || typeof swiper.destroy !== 'function') return;
        swiper.destroy(true, true);
      }
    }

    if (!customElements.get('alp-cp-articles')) {
      customElements.define('alp-cp-articles', AlpCpArticles);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-compare-brand-core"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpCompareBrandCore extends HTMLElement {
      constructor() {
        super();
        this.onSelectChange = this.onSelectChange.bind(this);
      }

      connectedCallback() {
        this.publishData();
        this.selectLeft = this.querySelector('[data-cp-select="left"]');
        this.selectRight = this.querySelector('[data-cp-select="right"]');
        if (this.selectLeft) this.selectLeft.addEventListener('change', this.onSelectChange);
        if (this.selectRight) this.selectRight.addEventListener('change', this.onSelectChange);

        const leftHandle = (this.selectLeft && this.selectLeft.value) || this.dataset.leftHandle || '';
        const rightHandle = (this.selectRight && this.selectRight.value) || this.dataset.rightHandle || '';
        if (leftHandle && rightHandle) {
          this.applySelection(leftHandle, rightHandle);
        } else if (leftHandle) {
          this.applyLeftOnly(leftHandle);
        }
      }

      disconnectedCallback() {
        if (this.selectLeft) this.selectLeft.removeEventListener('change', this.onSelectChange);
        if (this.selectRight) this.selectRight.removeEventListener('change', this.onSelectChange);
      }

      getData() {
        return window.AlpCpCompareBrandData || null;
      }

      publishData(data) {
        const dataEl = this.querySelector('[data-alp-cp-compare-data]');
        if (data) {
          window.AlpCpCompareBrandData = data;
          if (dataEl) dataEl.textContent = JSON.stringify(data);
        } else if (dataEl) {
          try {
            window.AlpCpCompareBrandData = JSON.parse(dataEl.textContent);
          } catch (error) {
            console.warn('[alp-cp-compare-brand-core] Failed to parse compare data JSON.', error);
            return;
          }
        } else {
          return;
        }

        document.dispatchEvent(
          new CustomEvent('alp:cp-compare-data-ready', {
            detail: window.AlpCpCompareBrandData,
          })
        );
      }

      buildPagePath(leftHandle, rightHandle) {
        return `/pages/compare-${leftHandle}-vs-${rightHandle}`;
      }

      parseConfigTitle(title) {
        const raw = title || '';
        if (raw.includes('</b>')) {
          const parts = raw.split('</b>');
          const value = parts[0]
            .replace(/<b>/gi, '')
            .replace(/<[^>]+>/g, '')
            .trim();
          const label = parts
            .slice(1)
            .join('</b>')
            .replace(/<[^>]+>/g, '')
            .trim();
          return { value, label };
        }
        return { value: raw.replace(/<[^>]+>/g, '').trim(), label: '' };
      }

      findProduct(list, handle) {
        if (!Array.isArray(list)) return null;
        return list.find((item) => item && item.handle === handle) || null;
      }

      formatLeftPrice(product) {
        const prefix = this.dataset.pricePrefix || 'From';
        const suffix = this.dataset.priceSuffix || '';
        const formatted = product.price_formatted || '';
        return [prefix, formatted, suffix].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
      }

      ensureCard(side) {
        const cardsWrap = this.querySelector('.alp-cp-compare-brand-core__cards');
        if (!cardsWrap) return null;

        let card = this.querySelector(`[data-side="${side}"]`);
        if (!card) {
          card = document.createElement('article');
          card.className = 'alp-cp-compare-brand-core__card';
          card.dataset.side = side;
          if (side === 'left') {
            cardsWrap.insertBefore(card, cardsWrap.firstChild);
          } else {
            cardsWrap.appendChild(card);
          }
        }

        card.hidden = false;
        card.removeAttribute('hidden');

        if (!card.querySelector('.alp-cp-compare-brand-core__card-title')) {
          card.innerHTML = `
            <h3 class="alp-cp-compare-brand-core__card-title"></h3>
            <div class="alp-cp-compare-brand-core__card-image"></div>
            <div class="alp-cp-compare-brand-core__specs"></div>
            <p class="alp-cp-compare-brand-core__price"></p>
            ${
              side === 'left'
                ? `<div class="alp-cp-compare-brand-core__cta"><a class="button-type-primary alp-btn small" href="#"><span></span></a></div>`
                : `<div class="alp-cp-compare-brand-core__cta-spacer" aria-hidden="true"></div>`
            }
          `;
        }

        return card;
      }

      updateLeftCard(product) {
        const card = this.ensureCard('left');
        if (!card || !product) return;

        card.dataset.handle = product.handle || '';
        const titleEl = card.querySelector('.alp-cp-compare-brand-core__card-title');
        if (titleEl) {
          const vendor = product.vendor || '';
          const title = product.title || '';
          titleEl.textContent = `${vendor}${vendor && title ? ' · ' : ''}${title}`.toUpperCase();
        }

        const imageWrap = card.querySelector('.alp-cp-compare-brand-core__card-image');
        if (imageWrap) {
          if (product.image) {
            imageWrap.innerHTML = `<img src="${product.image}" alt="${
              product.title || ''
            }" width="1200" height="800" loading="lazy">`;
          } else {
            imageWrap.innerHTML = '';
          }
        }

        let specsEl = card.querySelector('.alp-cp-compare-brand-core__specs');
        const config = Array.isArray(product.product_configuration) ? product.product_configuration.slice(0, 4) : [];
        if (config.length) {
          if (!specsEl) {
            specsEl = document.createElement('div');
            specsEl.className = 'alp-cp-compare-brand-core__specs';
            const priceEl = card.querySelector('.alp-cp-compare-brand-core__price');
            card.insertBefore(specsEl, priceEl);
          }
          specsEl.innerHTML = config
            .map((item) => {
              const parsed = this.parseConfigTitle(item.title);
              const labelHtml = parsed.label
                ? `<div class="alp-cp-compare-brand-core__spec-label">${parsed.label}</div>`
                : '';
              return `<div class="alp-cp-compare-brand-core__spec"><div class="alp-cp-compare-brand-core__spec-value">${parsed.value}</div>${labelHtml}</div>`;
            })
            .join('');
        } else if (specsEl) {
          specsEl.innerHTML = '';
        }

        const priceEl = card.querySelector('.alp-cp-compare-brand-core__price');
        if (priceEl) priceEl.textContent = this.formatLeftPrice(product);

        const btn = card.querySelector('.alp-cp-compare-brand-core__cta .alp-btn');
        if (btn) {
          const prefix = this.dataset.buttonPrefix || 'View';
          btn.setAttribute('href', product.url || '#');
          const span = btn.querySelector('span');
          if (span) span.textContent = `${prefix} ${product.title || ''}`.trim();
        }
      }

      updateRightCard(product) {
        const card = this.ensureCard('right');
        if (!card || !product) return;

        card.dataset.handle = product.handle || '';
        const titleEl = card.querySelector('.alp-cp-compare-brand-core__card-title');
        if (titleEl) {
          if (product.display_title) {
            titleEl.textContent = product.display_title;
          } else {
            const brand = product.brand || '';
            const title = product.title || '';
            titleEl.textContent = `${brand}${brand && title ? ' · ' : ''}${title}`.toUpperCase();
          }
        }

        const imageWrap = card.querySelector('.alp-cp-compare-brand-core__card-image');
        if (imageWrap) {
          if (product.image) {
            imageWrap.innerHTML = `<img src="${product.image}" alt="${
              product.title || ''
            }" width="1200" height="800" loading="lazy">`;
          } else {
            imageWrap.innerHTML = '';
          }
        }

        let specsEl = card.querySelector('.alp-cp-compare-brand-core__specs');
        const config = Array.isArray(product.product_configuration) ? product.product_configuration.slice(0, 4) : [];
        if (config.length) {
          if (!specsEl) {
            specsEl = document.createElement('div');
            specsEl.className = 'alp-cp-compare-brand-core__specs';
            const priceEl = card.querySelector('.alp-cp-compare-brand-core__price');
            card.insertBefore(specsEl, priceEl || card.querySelector('.alp-cp-compare-brand-core__cta-spacer'));
          }
          specsEl.innerHTML = config
            .map((item) => {
              const parsed = this.parseConfigTitle(item.title);
              const labelHtml = parsed.label
                ? `<div class="alp-cp-compare-brand-core__spec-label">${parsed.label}</div>`
                : '';
              return `<div class="alp-cp-compare-brand-core__spec"><div class="alp-cp-compare-brand-core__spec-value">${parsed.value}</div>${labelHtml}</div>`;
            })
            .join('');
        } else if (specsEl) {
          specsEl.innerHTML = '';
        }

        const priceEl = card.querySelector('.alp-cp-compare-brand-core__price');
        if (priceEl) {
          if (product.price_label) {
            priceEl.textContent = product.price_label;
          } else if (product.price) {
            const prefix = this.dataset.pricePrefix || 'From';
            const suffix = this.dataset.priceSuffix || '';
            priceEl.textContent = [prefix, `$${product.price}`, suffix].filter(Boolean).join(' ');
          }
        }
      }

      applyLeftOnly(leftHandle) {
        const data = this.getData();
        if (!data) return false;
        const leftProduct = this.findProduct(data.leftProducts, leftHandle);
        if (!leftProduct) return false;
        this.updateLeftCard(leftProduct);
        this.dataset.leftHandle = leftHandle;
        return true;
      }

      applySelection(leftHandle, rightHandle) {
        const data = this.getData();
        if (!data) return false;

        const leftProduct = this.findProduct(data.leftProducts, leftHandle);
        const rightProduct = this.findProduct(data.rightProducts, rightHandle);

        if (leftProduct) this.updateLeftCard(leftProduct);
        if (rightProduct) this.updateRightCard(rightProduct);
        if (!leftProduct && !rightProduct) return false;

        this.dataset.leftHandle = leftHandle || this.dataset.leftHandle || '';
        this.dataset.rightHandle = rightHandle || this.dataset.rightHandle || '';
        if (this.selectLeft && leftHandle) this.selectLeft.value = leftHandle;
        if (this.selectRight && rightHandle) this.selectRight.value = rightHandle;

        data.selected = {
          left: this.dataset.leftHandle,
          right: this.dataset.rightHandle,
        };
        this.publishData(data);
        return Boolean(leftProduct || rightProduct);
      }

      isCompareSectionNode(node) {
        if (!node || node.nodeType !== 1) return false;
        if (node.tagName === 'ALP-CP-COMPARE-BRAND-CORE') return true;
        return Boolean(node.querySelector && node.querySelector('alp-cp-compare-brand-core'));
      }

      replaceMainPreservingSelf(nextMain, currentMain) {
        const preserveRoot = this.closest('.shopify-section') || this;
        const fragment = document.createDocumentFragment();
        let preserved = false;

        Array.from(nextMain.children).forEach((child) => {
          if (this.isCompareSectionNode(child)) {
            if (!preserved) {
              fragment.appendChild(preserveRoot);
              preserved = true;
            }
            return;
          }
          fragment.appendChild(document.importNode(child, true));
        });

        if (!preserved) {
          fragment.appendChild(preserveRoot);
        }

        currentMain.replaceChildren(fragment);
      }

      async onSelectChange() {
        const leftHandle = this.selectLeft ? this.selectLeft.value : '';
        const rightHandle = this.selectRight ? this.selectRight.value : '';
        if (!leftHandle || !rightHandle) {
          console.warn('[alp-cp-compare-brand-core] Missing left or right product handle; skip refresh.');
          return;
        }

        const currentLeft = this.dataset.leftHandle;
        const currentRight = this.dataset.rightHandle;
        if (leftHandle === currentLeft && rightHandle === currentRight) return;

        const path = this.buildPagePath(leftHandle, rightHandle);
        this.dataset.loading = 'true';

        try {
          const applied = this.applySelection(leftHandle, rightHandle);
          if (!applied) {
            throw new Error(`Product data not found for ${leftHandle} / ${rightHandle}`);
          }

          const response = await fetch(path, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) {
            throw new Error(`Page not found or unavailable (${response.status}): ${path}`);
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextMain = doc.querySelector('main#MainContent');
          const currentMain = document.querySelector('main#MainContent');

          if (!nextMain || !currentMain) {
            throw new Error('main#MainContent not found in response or current document.');
          }

          this.replaceMainPreservingSelf(nextMain, currentMain);
          history.pushState({ alpCpCompare: true }, '', path);
          document.dispatchEvent(
            new CustomEvent('alp:cp-compare-page-replaced', {
              detail: {
                path,
                leftHandle,
                rightHandle,
                preserved: 'alp-cp-compare-brand-core',
                compareData: window.AlpCpCompareBrandData || null,
              },
            })
          );
        } catch (error) {
          console.warn(
            '[alp-cp-compare-brand-core] Fetch refresh failed; keep selected products and current page content.',
            '\nTried path:',
            path,
            '\nReason:',
            error && error.message ? error.message : error
          );
        } finally {
          this.dataset.loading = 'false';
        }
      }
    }

    if (!customElements.get('alp-cp-compare-brand-core')) {
      customElements.define('alp-cp-compare-brand-core', AlpCpCompareBrandCore);
    }

    if (!window.__alpCpComparePopstateBound) {
      window.__alpCpComparePopstateBound = true;
      window.addEventListener('popstate', async () => {
        const currentMain = document.querySelector('main#MainContent');
        const liveModule = document.querySelector('alp-cp-compare-brand-core');
        if (!currentMain) return;
        try {
          const response = await fetch(window.location.pathname, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextMain = doc.querySelector('main#MainContent');
          if (!nextMain) throw new Error('main#MainContent missing');

          if (liveModule && typeof liveModule.replaceMainPreservingSelf === 'function') {
            liveModule.replaceMainPreservingSelf(nextMain, currentMain);
            const match = window.location.pathname.match(/compare-(.+)-vs-(.+)/);
            if (match) {
              liveModule.applySelection(match[1], match[2]);
            }
          } else {
            currentMain.innerHTML = nextMain.innerHTML;
          }
        } catch (error) {
          console.warn('[alp-cp-compare-brand-core] popstate refresh failed.', error);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpCta extends HTMLElement {
      constructor() {
        super();
        this.onCompareDataReady = this.onCompareDataReady.bind(this);
      }

      connectedCallback() {
        this.titleEl = this.querySelector('[data-cp-cta-title]');
        this.btnEl = this.querySelector('[data-cp-cta-btn]');

        document.addEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.addEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);

        this.renderFromData(this.getCompareData());
      }

      disconnectedCallback() {
        document.removeEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.removeEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);
      }

      onCompareDataReady(event) {
        const detail = event && event.detail;
        let data = null;
        if (detail && Array.isArray(detail.leftProducts)) {
          data = detail;
        } else if (detail && detail.compareData && Array.isArray(detail.compareData.leftProducts)) {
          data = detail.compareData;
        } else {
          data = this.getCompareData();
        }
        this.renderFromData(data);
      }

      getCompareData() {
        if (window.AlpCpCompareBrandData && Array.isArray(window.AlpCpCompareBrandData.leftProducts)) {
          return window.AlpCpCompareBrandData;
        }

        const dataEl =
          document.querySelector('alp-cp-compare-brand-core [data-alp-cp-compare-data]') ||
          document.querySelector('[data-alp-cp-compare-data]');
        if (!dataEl) return null;

        try {
          const data = JSON.parse(dataEl.textContent);
          window.AlpCpCompareBrandData = data;
          return data;
        } catch (error) {
          console.warn('[alp-cp-cta] Failed to parse compare data.', error);
          return null;
        }
      }

      findProduct(list, handle) {
        if (!Array.isArray(list) || !handle) return null;
        return list.find((item) => item && item.handle === handle) || null;
      }

      productDisplayName(product, fallback) {
        if (!product) return fallback || '';
        return product.title || product.select_label || product.display_title || fallback || '';
      }

      applyTemplate(template, leftName) {
        return String(template || '').replace(/\{left\}/g, leftName || '—');
      }

      renderFromData(data) {
        const selected = (data && data.selected) || {};
        const leftProduct = this.findProduct(data && data.leftProducts, selected.left);
        const leftName = this.productDisplayName(leftProduct, selected.left);
        const titleTemplate = this.dataset.titleTemplate || 'Ready to ride {left}?';
        const buttonTemplate = this.dataset.buttonLabelTemplate || 'Shop {left}';
        const urlOverride = (this.dataset.buttonUrlOverride || '').trim();

        if (this.titleEl) {
          this.titleEl.textContent = this.applyTemplate(titleTemplate, leftName);
        }

        if (this.btnEl) {
          this.btnEl.textContent = this.applyTemplate(buttonTemplate, leftName);
          if (urlOverride) {
            this.btnEl.setAttribute('href', urlOverride);
          } else if (leftProduct && leftProduct.url) {
            this.btnEl.setAttribute('href', leftProduct.url);
          }
        }
      }
    }

    if (!customElements.get('alp-cp-cta')) {
      customElements.define('alp-cp-cta', AlpCpCta);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpFaqs extends HTMLElement {
      constructor() {
        super();
        this.onCompareDataReady = this.onCompareDataReady.bind(this);
        this.onToggleClick = this.onToggleClick.bind(this);
        this.onCopyClick = this.onCopyClick.bind(this);
      }

      connectedCallback() {
        this.titleEl = this.querySelector('[data-cp-faqs-title]');
        this.listEl = this.querySelector('[data-cp-faqs-list]');
        this.copyBtn = this.querySelector('[data-cp-faqs-copy]');

        if (this.listEl) {
          this.listEl.addEventListener('click', this.onToggleClick);
        }
        if (this.copyBtn) {
          this.copyBtn.addEventListener('click', this.onCopyClick);
        }

        document.addEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.addEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);

        this.renderFromData(this.getCompareData());
      }

      disconnectedCallback() {
        if (this.listEl) {
          this.listEl.removeEventListener('click', this.onToggleClick);
        }
        if (this.copyBtn) {
          this.copyBtn.removeEventListener('click', this.onCopyClick);
        }
        document.removeEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.removeEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);
      }

      onToggleClick(event) {
        const toggle = event.target.closest('[data-cp-faqs-toggle]');
        if (!toggle || !this.listEl.contains(toggle)) return;

        const item = toggle.closest('[data-cp-faqs-item]');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');
        this.querySelectorAll('[data-cp-faqs-item]').forEach((el) => {
          const isCurrent = el === item && willOpen;
          el.classList.toggle('is-open', isCurrent);
          const btn = el.querySelector('[data-cp-faqs-toggle]');
          const answer = el.querySelector('[data-cp-faqs-answer]');
          if (btn) btn.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
          if (answer) {
            if (isCurrent) answer.removeAttribute('inert');
            else answer.setAttribute('inert', '');
          }
        });
      }

      onCopyClick() {
        const url = this.dataset.shareUrl || window.location.href;
        const done = () => {
          this.copyBtn.setAttribute('aria-label', 'Link copied');
          window.setTimeout(() => {
            this.copyBtn.setAttribute('aria-label', 'Copy link');
          }, 1600);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(url)
            .then(done)
            .catch(() => {
              window.prompt('Copy this link', url);
            });
          return;
        }

        window.prompt('Copy this link', url);
      }

      onCompareDataReady(event) {
        const detail = event && event.detail;
        let data = null;
        if (detail && Array.isArray(detail.leftProducts)) {
          data = detail;
        } else if (detail && detail.compareData && Array.isArray(detail.compareData.leftProducts)) {
          data = detail.compareData;
        } else {
          data = this.getCompareData();
        }
        this.renderFromData(data);
      }

      getCompareData() {
        if (window.AlpCpCompareBrandData && Array.isArray(window.AlpCpCompareBrandData.leftProducts)) {
          return window.AlpCpCompareBrandData;
        }

        const dataEl =
          document.querySelector('alp-cp-compare-brand-core [data-alp-cp-compare-data]') ||
          document.querySelector('[data-alp-cp-compare-data]');
        if (!dataEl) return null;

        try {
          const data = JSON.parse(dataEl.textContent);
          window.AlpCpCompareBrandData = data;
          return data;
        } catch (error) {
          console.warn('[alp-cp-faqs] Failed to parse compare data.', error);
          return null;
        }
      }

      findProduct(list, handle) {
        if (!Array.isArray(list) || !handle) return null;
        return list.find((item) => item && item.handle === handle) || null;
      }

      productDisplayName(product, fallback) {
        if (!product) return fallback || '';
        return product.title || product.select_label || product.display_title || fallback || '';
      }

      renderFromData(data) {
        if (!this.titleEl) return;

        const selected = (data && data.selected) || {};
        const leftProduct = this.findProduct(data && data.leftProducts, selected.left);
        const rightProduct = this.findProduct(data && data.rightProducts, selected.right);
        const leftName = this.productDisplayName(leftProduct, selected.left) || '—';
        const rightName = this.productDisplayName(rightProduct, selected.right) || '—';
        const template = this.dataset.titleTemplate || '{left} vs {right} FAQs';

        this.titleEl.textContent = template.replace(/\{left\}/g, leftName).replace(/\{right\}/g, rightName);
      }
    }

    if (!customElements.get('alp-cp-faqs')) {
      customElements.define('alp-cp-faqs', AlpCpFaqs);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpHeroBanner extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('alp-cp-hero-banner', AlpCpHeroBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-key-diff"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpKeyDiff extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('alp-cp-key-diff', AlpCpKeyDiff);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-related-blogs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpRelatedBlogs extends HTMLElement {
      connectedCallback() {
        this.swiperEl = this.querySelector('[data-cp-related-blogs-swiper]');
        if (!this.swiperEl || typeof Swiper === 'undefined') return;
        if (this.swiper && !this.swiper.destroyed) return;

        this.navEl = this.querySelector('[data-cp-related-blogs-nav]');
        this.scrollbarEl = this.querySelector('[data-cp-related-blogs-scrollbar]');
        this.updateOverflowState = this.updateOverflowState.bind(this);
        this.onResize = this.onResize.bind(this);

        const layout = this.getLayout();
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: layout.slidesPerView,
          spaceBetween: layout.spaceBetween,
          watchOverflow: true,
          resizeObserver: true,
          pagination: {
            el: this.querySelector('.pagination-cp-related-blogs'),
            clickable: true,
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          scrollbar: {
            el: this.scrollbarEl,
            draggable: true,
            hide: false,
          },
          on: {
            init: this.updateOverflowState,
            resize: this.updateOverflowState,
            slidesLengthChange: this.updateOverflowState,
            update: this.updateOverflowState,
          },
        });

        window.addEventListener('resize', this.onResize);
        requestAnimationFrame(() => {
          this.applyLayout(true);
          if (this.swiper && this.swiper.el && this.swiper.el.offsetWidth === 0) {
            requestAnimationFrame(() => this.applyLayout(true));
          }
        });
      }

      getLayout() {
        const width = window.innerWidth;
        if (width >= 1024) return { slidesPerView: 3, spaceBetween: 24 };
        if (width >= 768) return { slidesPerView: 2.2, spaceBetween: 20 };
        return { slidesPerView: 1.1, spaceBetween: 16 };
      }

      onResize() {
        this.applyLayout();
      }

      applyLayout(forceUpdate) {
        const swiper = this.swiper;
        if (!this.isConnected || !swiper || swiper.destroyed || !swiper.params) return;

        const layout = this.getLayout();
        const changed =
          swiper.params.slidesPerView !== layout.slidesPerView || swiper.params.spaceBetween !== layout.spaceBetween;

        if (changed) {
          swiper.params.slidesPerView = layout.slidesPerView;
          swiper.params.spaceBetween = layout.spaceBetween;
          swiper.update();
          return;
        }

        if (forceUpdate && swiper.el && swiper.el.offsetWidth > 0) {
          swiper.update();
        }
      }

      updateOverflowState(swiperInstance) {
        if (!this.isConnected) return;

        const swiper =
          swiperInstance && swiperInstance.params && !swiperInstance.destroyed ? swiperInstance : this.swiper;
        if (!swiper || swiper.destroyed || !swiper.params || !swiper.slides) return;

        const slidesPerView = swiper.params.slidesPerView;
        if (slidesPerView == null) return;

        const visibleCount = slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Number(slidesPerView);
        const isOverflow = swiper.slides.length > visibleCount + 0.001;
        this.classList.toggle('is-overflow', isOverflow);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        const swiper = this.swiper;
        this.swiper = null;
        if (!swiper || swiper.destroyed || typeof swiper.destroy !== 'function') return;
        swiper.destroy(true, true);
      }
    }

    if (!customElements.get('alp-cp-related-blogs')) {
      customElements.define('alp-cp-related-blogs', AlpCpRelatedBlogs);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-specifications"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpSpecifications extends HTMLElement {
      constructor() {
        super();
        this.onCompareDataReady = this.onCompareDataReady.bind(this);
      }

      connectedCallback() {
        this.titleEl = this.querySelector('[data-cp-spec-title]');
        this.tableWrap = this.querySelector('[data-cp-spec-table-wrap]');
        this.bodyEl = this.querySelector('[data-cp-spec-body]');
        this.emptyEl = this.querySelector('[data-cp-spec-empty]');
        this.colLabel = this.querySelector('[data-cp-spec-col="label"]');
        this.colLeft = this.querySelector('[data-cp-spec-col="left"]');
        this.colRight = this.querySelector('[data-cp-spec-col="right"]');

        document.addEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.addEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);

        this.renderFromData(this.getCompareData());
      }

      disconnectedCallback() {
        document.removeEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.removeEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);
      }

      onCompareDataReady(event) {
        const detail = event && event.detail;
        let data = null;
        if (detail && Array.isArray(detail.leftProducts)) {
          data = detail;
        } else if (detail && detail.compareData && Array.isArray(detail.compareData.leftProducts)) {
          data = detail.compareData;
        } else {
          data = this.getCompareData();
        }
        this.renderFromData(data);
      }

      getCompareData() {
        if (window.AlpCpCompareBrandData && Array.isArray(window.AlpCpCompareBrandData.leftProducts)) {
          return window.AlpCpCompareBrandData;
        }

        const dataEl =
          document.querySelector('alp-cp-compare-brand-core [data-alp-cp-compare-data]') ||
          document.querySelector('[data-alp-cp-compare-data]');
        if (!dataEl) return null;

        try {
          const data = JSON.parse(dataEl.textContent);
          window.AlpCpCompareBrandData = data;
          return data;
        } catch (error) {
          console.warn('[alp-cp-specifications] Failed to parse compare data.', error);
          return null;
        }
      }

      parseKeys(raw) {
        return String(raw || '')
          .split(/[;\n]+/)
          .map((item) => item.trim())
          .filter(Boolean);
      }

      escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      findProduct(list, handle) {
        if (!Array.isArray(list) || !handle) return null;
        return list.find((item) => item && item.handle === handle) || null;
      }

      findSpecValue(comparison, key) {
        if (!Array.isArray(comparison) || !key) return '';
        const target = key.toLowerCase();
        const matched = comparison.find((item) => {
          const title = (item && item.title ? String(item.title) : '').trim().toLowerCase();
          return title === target;
        });
        if (!matched) return '';
        return matched.dec != null ? String(matched.dec) : '';
      }

      productDisplayName(product, fallback) {
        if (!product) return fallback || '';
        return product.title || product.select_label || product.display_title || fallback || '';
      }

      renderFromData(data) {
        if (!this.bodyEl) return;

        const specKeys = this.parseKeys(this.dataset.specKeys);
        const highlightKeys = this.parseKeys(this.dataset.highlightKeys).map((item) => item.toLowerCase());
        const selected = (data && data.selected) || {};
        const leftProduct = this.findProduct(data && data.leftProducts, selected.left);
        const rightProduct = this.findProduct(data && data.rightProducts, selected.right);

        if (!leftProduct || !rightProduct || !specKeys.length) {
          if (this.tableWrap) this.tableWrap.hidden = true;
          if (this.emptyEl) this.emptyEl.hidden = false;
          if (this.titleEl) {
            const template = this.dataset.titleTemplate || '{left} vs {right} specifications';
            this.titleEl.textContent = template.replace('{left}', '—').replace('{right}', '—');
          }
          return;
        }

        const leftName = this.productDisplayName(leftProduct, selected.left);
        const rightName = this.productDisplayName(rightProduct, selected.right);
        const template = this.dataset.titleTemplate || '{left} vs {right} specifications';

        if (this.titleEl) {
          this.titleEl.textContent = template.replace('{left}', leftName).replace('{right}', rightName);
        }
        if (this.colLabel) this.colLabel.textContent = this.dataset.specHeader || 'Specification';
        if (this.colLeft) this.colLeft.textContent = leftName;
        if (this.colRight) this.colRight.textContent = rightName;

        const leftComparison = Array.isArray(leftProduct.product_comparison) ? leftProduct.product_comparison : [];
        const rightComparison = Array.isArray(rightProduct.product_comparison) ? rightProduct.product_comparison : [];

        this.bodyEl.innerHTML = specKeys
          .map((key) => {
            const leftValue = this.findSpecValue(leftComparison, key);
            const rightValue = this.findSpecValue(rightComparison, key);
            const highlight = highlightKeys.includes(key.toLowerCase()) && leftValue;
            return `<tr>
              <td>${this.escapeHtml(key)}</td>
              <td class="${highlight ? 'is-highlight' : ''}">${this.escapeHtml(leftValue || '—')}</td>
              <td>${this.escapeHtml(rightValue || '—')}</td>
            </tr>`;
          })
          .join('');

        if (this.tableWrap) this.tableWrap.hidden = false;
        if (this.emptyEl) this.emptyEl.hidden = true;
      }
    }

    if (!customElements.get('alp-cp-specifications')) {
      customElements.define('alp-cp-specifications', AlpCpSpecifications);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-value-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpValueCompare extends HTMLElement {
      constructor() {
        super();
        this.onCompareDataReady = this.onCompareDataReady.bind(this);
      }

      connectedCallback() {
        this.titleEl = this.querySelector('[data-cp-value-title]');
        this.subtitleEl = this.querySelector('[data-cp-value-subtitle]');
        this.tableWrap = this.querySelector('[data-cp-value-table-wrap]');
        this.bodyEl = this.querySelector('[data-cp-value-body]');
        this.emptyEl = this.querySelector('[data-cp-value-empty]');
        this.colLabel = this.querySelector('[data-cp-value-col="label"]');
        this.colLeft = this.querySelector('[data-cp-value-col="left"]');
        this.colRight = this.querySelector('[data-cp-value-col="right"]');

        document.addEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.addEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);

        this.renderFromData(this.getCompareData());
      }

      disconnectedCallback() {
        document.removeEventListener('alp:cp-compare-data-ready', this.onCompareDataReady);
        document.removeEventListener('alp:cp-compare-page-replaced', this.onCompareDataReady);
      }

      onCompareDataReady(event) {
        const detail = event && event.detail;
        let data = null;
        if (detail && Array.isArray(detail.leftProducts)) {
          data = detail;
        } else if (detail && detail.compareData && Array.isArray(detail.compareData.leftProducts)) {
          data = detail.compareData;
        } else {
          data = this.getCompareData();
        }
        this.renderFromData(data);
      }

      getCompareData() {
        if (window.AlpCpCompareBrandData && Array.isArray(window.AlpCpCompareBrandData.leftProducts)) {
          return window.AlpCpCompareBrandData;
        }

        const dataEl =
          document.querySelector('alp-cp-compare-brand-core [data-alp-cp-compare-data]') ||
          document.querySelector('[data-alp-cp-compare-data]');
        if (!dataEl) return null;

        try {
          const data = JSON.parse(dataEl.textContent);
          window.AlpCpCompareBrandData = data;
          return data;
        } catch (error) {
          console.warn('[alp-cp-value-compare] Failed to parse compare data.', error);
          return null;
        }
      }

      parseKeys(raw) {
        return String(raw || '')
          .split(/[;\n]+/)
          .map((item) => item.trim())
          .filter(Boolean);
      }

      escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      findProduct(list, handle) {
        if (!Array.isArray(list) || !handle) return null;
        return list.find((item) => item && item.handle === handle) || null;
      }

      findSpecValue(comparison, key) {
        if (!Array.isArray(comparison) || !key) return '';
        const target = key.toLowerCase();
        const matched = comparison.find((item) => {
          const title = (item && item.title ? String(item.title) : '').trim().toLowerCase();
          return title === target;
        });
        if (!matched) return '';
        return matched.dec != null ? String(matched.dec) : '';
      }

      productDisplayName(product, fallback) {
        if (!product) return fallback || '';
        return product.title || product.select_label || product.display_title || fallback || '';
      }

      renderFromData(data) {
        if (!this.bodyEl) return;

        const specKeys = this.parseKeys(this.dataset.specKeys);
        const highlightKeys = this.parseKeys(this.dataset.highlightKeys).map((item) => item.toLowerCase());
        const selected = (data && data.selected) || {};
        const leftProduct = this.findProduct(data && data.leftProducts, selected.left);
        const rightProduct = this.findProduct(data && data.rightProducts, selected.right);
        const template = this.dataset.titleTemplate || 'Value, compared clearly.';

        if (!leftProduct || !rightProduct || !specKeys.length) {
          if (this.tableWrap) this.tableWrap.hidden = true;
          if (this.emptyEl) this.emptyEl.hidden = false;
          if (this.titleEl) {
            this.titleEl.textContent = template.replace('{left}', '—').replace('{right}', '—');
          }
          return;
        }

        const leftName = this.productDisplayName(leftProduct, selected.left);
        const rightName = this.productDisplayName(rightProduct, selected.right);

        if (this.titleEl) {
          this.titleEl.textContent = template.replace('{left}', leftName).replace('{right}', rightName);
        }
        if (this.subtitleEl) {
          const subtitle = this.dataset.subtitle || '';
          this.subtitleEl.textContent = subtitle;
          this.subtitleEl.hidden = !subtitle;
        }
        if (this.colLabel) this.colLabel.textContent = this.dataset.specHeader || 'Included value';
        if (this.colLeft) this.colLeft.textContent = leftName;
        if (this.colRight) this.colRight.textContent = rightName;

        const leftComparison = Array.isArray(leftProduct.product_comparison) ? leftProduct.product_comparison : [];
        const rightComparison = Array.isArray(rightProduct.product_comparison) ? rightProduct.product_comparison : [];

        this.bodyEl.innerHTML = specKeys
          .map((key) => {
            const leftValue = this.findSpecValue(leftComparison, key);
            const rightValue = this.findSpecValue(rightComparison, key);
            const highlight = highlightKeys.includes(key.toLowerCase()) && leftValue;
            return `<tr>
              <td>${this.escapeHtml(key)}</td>
              <td class="${highlight ? 'is-highlight' : ''}">${this.escapeHtml(leftValue || '—')}</td>
              <td>${this.escapeHtml(rightValue || '—')}</td>
            </tr>`;
          })
          .join('');

        if (this.tableWrap) this.tableWrap.hidden = false;
        if (this.emptyEl) this.emptyEl.hidden = true;
      }
    }

    if (!customElements.get('alp-cp-value-compare')) {
      customElements.define('alp-cp-value-compare', AlpCpValueCompare);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-cp-which-bike-fit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class AlpCpWhichBikeFit extends HTMLElement {
      constructor() {
        super();
      }
    }
    if (!customElements.get('alp-cp-which-bike-fit')) {
      customElements.define('alp-cp-which-bike-fit', AlpCpWhichBikeFit);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-global-compare-full"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    class GlobalCompare {
      // checkbox : .global-compare-checkbox with [data-product-id]
      // trigger : [data-global-compare-open] with [data-global-compare-open=' product.id ']
      // options selector : .global-compare-selector
      // options : .global-compare-options with [data-product-id]
      // floating tab: .global-compare-floating-tab

      constructor() {
        // 存储事件处理函数
        this.checkboxs = [];
        this.eventListeners = new Map();
        this.compareParent = document.querySelector('.global-compare');
        this.floatingTab = document.querySelector('.global-compare-floating-tab');
        this.init();
      }

      init() {
        this.removePreloadProducts();
        this.triggerSelectOpen();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.hanldeSelectorChange();
        this.findTheItemsDiff();
        this.triggerOpen();
        this.triggerCompareCheckboxInit();
        this.updateFlotingTabStatus(this.getCookie());
        this.clickFlotingTab();
        window.addEventListener('resize', () => this.setSameHeightForItems());
        window.addEventListener('CompareTrigger', () => this.checkboxEventUpdate());
        this.compareParent.querySelector('.global-compare-diff-trigger').addEventListener('click', () => {
          this.compareParent.classList.toggle('show_diff');
          this.setSameHeightForItems();
        });
      }

      triggerSelectOpen() {
        const globalCompareSelector = document.querySelector('.global-compare-selector span');
        const globalCompareOptions = globalCompareSelector
          .closest('.global-compare-selector')
          .querySelector('.global-compare-options');
        globalCompareSelector.addEventListener('click', () => {
          globalCompareOptions.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.global-compare-selector')) {
            globalCompareOptions.classList.add('hidden');
          }
        });
      }

      updateSelectedProduct() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.classList.remove('selected');
        });
        options.forEach((option) => {
          const productId = option.dataset.productId;
          const productEl = this.compareParent.querySelector(
            `.products-new-compare-wrapper [data-product-id="${productId}"]`
          );
          if (productEl) option.classList.add('selected');
        });
      }

      setSameHeightForItems() {
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx_compare_spec_list'
        );
        const items = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        // 重置高度
        rows.forEach((row) => {
          row.querySelectorAll('.axx_compare_spec_list_item').forEach((item) => {
            item.style.setProperty('--height', 'auto');
          });
        });
        // 设置规格高度
        items.forEach((_, index) => {
          let maxHeight = 0;
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            item.style.setProperty('--height', `${maxHeight}px`);
          });
        });
        // 设置图片高度
        const imageWrappers = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx-images-with-swatch'
        );
        const maxImageHeight = Math.max(...[...imageWrappers].map((img) => img.offsetHeight), 0);
        imageWrappers.forEach((img) => img.style.setProperty('--height', `${maxImageHeight}px`));
      }

      hanldeSelectorChange() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.addEventListener('click', () => {
            const productId = option.dataset.productId;
            option.classList.toggle('selected');
            option.classList.contains('selected') ? this.addProduct(productId) : this.removeProduct(productId);
          });
        });
      }

      removePreloadProducts() {
        this.compareParent
          .querySelectorAll('.products-new-compare-wrapper .product-new-compare-item[data-product-id]')
          .forEach((el) => el.remove());
      }

      async addProduct(ids) {
        // 处理多id输入并去重
        const idArray = Array.isArray(ids)
          ? ids
          : ids
              .toString()
              .split(',')
              .filter((id) => id.trim() !== '');
        const uniqueIds = [...new Set(idArray)];
        const fetchUrl = this.compareParent.dataset.fetchUrl;
        this.compareParent.classList.add('loading');
        // compare ids and the existing products `.product-new-compare-item[data-product-id="${id}"]`
        const existingProducts = this.compareParent.querySelectorAll('.product-new-compare-item[data-product-id]');
        const existingIds = [...existingProducts].map((el) => el.dataset.productId);
        const newIds = uniqueIds.filter((id) => !existingIds.includes(id));
        if (newIds.length === 0) {
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          return;
        }
        // continue to add products
        try {
          const response = await fetch(fetchUrl);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceParents = html.querySelectorAll('.products-new-compare-wrapper');
          const targetWrappers = this.compareParent.querySelectorAll('.products-new-compare-wrapper');
          // 遍历每个唯一id添加产品
          uniqueIds.forEach((id) => {
            sourceParents.forEach((sourceEl, index) => {
              const targetEl = targetWrappers[index];
              if (!targetEl) return;
              const exitProductEl = targetEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              // if (exitProductEl) exitProductEl.remove();
              if (exitProductEl) return;
              const productEl = sourceEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              if (productEl) targetEl.appendChild(productEl);
              const removeEl = productEl.querySelector('.product-compare-remove');
              if (removeEl) this.handleRemoveProductTrigger(removeEl);
            });
          });
        } finally {
          this.findTheItemsDiff();
          this.updateSelectedProduct();
          this.setSameHeightForItems();
          if (window.axxVariantsSwatch) window.axxVariantsSwatch.update();
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          this.setCookie();
          this.updateCheckboxStatus();
        }
      }

      removeProduct(id) {
        this.compareParent
          .querySelectorAll(`.products-new-compare-wrapper [data-product-id="${id}"]`)
          .forEach((el) => el.remove());
        this.findTheItemsDiff();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.setCookie();
        this.updateCheckboxStatus();
      }

      handleRemoveProductTrigger(el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = el.closest('.product-new-compare-item');
          const productId = parent.dataset.productId;
          this.removeProduct(productId);
        });
      }

      setCookie() {
        const uniqueIds = [];
        this.compareParent
          .querySelectorAll('.global-compare-option.selected')
          .forEach((el) => uniqueIds.push(el.dataset.productId));
        // 存储id到cookie（30天过期）
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${uniqueIds.join(',')}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(`${uniqueIds.join(',')}`);
      }

      getCookie() {
        // let presetIds = this.compareParent.dataset.presetProducts;
        const cookieValue =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('selectedIds='))
            ?.split('=')[1] || '';
        if (cookieValue) {
          return cookieValue;
        }
      }

      addIdToCookie(id) {
        let ids = this.getCookie();
        if (!ids) {
          ids = id;
        } else {
          ids = `${ids},${id}`;
        }
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(ids);
      }

      removeIdFromCookie(id) {
        let ids = this.getCookie();
        if (ids) {
          ids = ids
            .split(',')
            .filter((i) => i !== id)
            .join(',');
          const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
          this.updateFlotingTabStatus(ids);
        }
      }

      findTheItemsDiff() {
        document
          .querySelectorAll(
            '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list .axx_compare_spec_list_item'
          )
          .forEach((item) => {
            item.classList.remove('diff');
          });
        const allRows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list'
        );
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data [data-product-id] .axx_compare_spec_list'
        );
        const firstRowItems = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        firstRowItems.forEach((_, index) => {
          const values = [...rows].map(
            (row) => row.querySelectorAll('.axx_compare_spec_list_item')[index]?.querySelector('.axcp-desc').textContent
          );
          const hasDiff = new Set(values).size > 1;
          if (hasDiff) {
            allRows.forEach((row) => {
              row.querySelectorAll('.axx_compare_spec_list_item')[index].classList.add('diff');
            });
          }
        });
      }

      triggerCompareCheckboxInit() {
        this.checkboxs = document.querySelectorAll('.global-compare-checkbox');
        if (this.checkboxs.length > 0) {
          this.updateCheckboxStatus();
          this.checkboxs.forEach((checkbox) => {
            const handler = (e) => this.checkboxToggle(checkbox);
            this.eventListeners.set(checkbox, handler);
            checkbox.addEventListener('click', handler);
          });
        }
      }

      checkboxEventUpdate() {
        this.checkboxs.forEach((checkbox) => {
          const handler = this.eventListeners.get(checkbox);
          if (handler) {
            checkbox.removeEventListener('click', handler);
          }
        });
        this.triggerCompareCheckboxInit();
      }

      checkboxToggle(checkbox) {
        const productId = checkbox.dataset.productId;
        if (checkbox.classList.contains('checked')) {
          checkbox.classList.remove('checked');
          this.removeIdFromCookie(productId);
        } else {
          this.addIdToCookie(productId);
        }
        this.updateCheckboxStatus();
      }

      updateCheckboxStatus() {
        let ids = this.getCookie();
        // remove class
        this.checkboxs.forEach((checkbox) => {
          checkbox.classList.remove('checked');
        });
        // update classlist
        if (ids) {
          ids.split(',').forEach((id) => {
            this.checkboxs.forEach((checkbox) => {
              let checkboxId = parseInt(checkbox.dataset.productId);
              if (checkboxId == id) {
                checkbox.classList.add('checked');
              }
            });
          });
          this.updateFlotingTabStatus(ids);
        }
      }

      updateFlotingTabStatus(selectedIds) {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        if (selectedIds) {
          const selectedIdsArray = selectedIds.split(',');
          const selectedIdsCount = selectedIdsArray.length;
          if (selectedIdsCount > 0) {
            floatingTab.classList.add('show');
          } else {
            floatingTab.classList.remove('show');
          }
          floatingTab.querySelector('.compare-products-count').textContent = selectedIdsCount;
        } else {
          floatingTab.classList.remove('show');
        }
      }

      clickFlotingTab() {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        floatingTab.addEventListener('click', (e) => {
          e.preventDefault();
          let ids = this.getCookie() ? this.getCookie() : presetIds;
          if (ids) {
            this.addProduct(ids);
            this.compareParent.classList.remove('hidden');
          }
        });
      }

      triggerOpen() {
        const triggers = document.querySelectorAll('[data-global-compare-open]');
        triggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = el.dataset.globalCompareOpen || 'null';
            const productEl = this.compareParent.querySelector(
              `.product-new-compare-item[data-product-id="${productId}"]`
            );
            if (productEl) {
              this.compareParent.classList.remove('hidden');
              this.setSameHeightForItems();
            } else {
              let presetIds = this.compareParent.dataset.presetProducts;
              let ids = this.getCookie() ? this.getCookie() : presetIds;
              if (!ids) {
                ids = productId;
              } else {
                ids = `${ids},${productId}`;
              }
              this.addProduct(ids);
              this.compareParent.classList.remove('hidden');
            }
          });
        });
        const closeTriggers = this.compareParent.querySelectorAll('.global-compare-close, .global-compare-overlay');
        closeTriggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareParent.classList.add('hidden');
          });
        });
      }
    }

    window.axxGlobalCompare = new GlobalCompare();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-page-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-list-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    $('.faq-new-box .container-pc .faq-box .faq-item .title').click(function () {
      let $this = $(this).parent();
      $this.toggleClass('active').siblings().removeClass('active');
      $this.find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideToggle(400);
      $this.siblings().find('.faq-new-box .container-pc .faq-box .faq-item .faq-list').slideUp(400);
    });

    // FAQ折叠功能（事件委托）
    const faqList = document.querySelectorAll('.container-pc .faq-box .faq-item .faq-list');
    faqList.forEach((list) => {
      list.addEventListener('click', (e) => {
        const quest = e.target.closest('.quest');
        if (quest) {
          quest.closest('.item').classList.toggle('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-product-sticky-banner"] && !Shopify.designMode) return;
  try {
    
  class LXProductStickyBanner extends HTMLElement {
    constructor() {
      super();
      this._syncingQuantity = false;
      this._lastScrollY = window.scrollY;
      this._headerHidden = false;
      this._onScroll = this.handleScroll.bind(this);
      this._onTabClick = this.handleTabClick.bind(this);
      this._onAddToCartClick = this.handleAddToCartClick.bind(this);
      this._onBannerQuantityChange = this.handleBannerQuantityChange.bind(this);
      this._onFormQuantityChange = this.handleFormQuantityChange.bind(this);
      this._onProductDetailUpdated = this.handleProductDetailUpdated.bind(this);
      this._onFormLoadingChange = this.handleFormLoadingChange.bind(this);
      this._syncTopHeight = this.syncTopHeight.bind(this);
    }

    connectedCallback() {
      this.productDetailEl = document.querySelector('[data-product-detail]');
      this.productFormEl = document.querySelector('form.lx-product-form');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.addToCartBtn = this.querySelector('[data-product-sticky-banner-add-to-cart]');

      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.addEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.addEventListener('click', this._onAddToCartClick);
      this.bindQuantityListeners();

      this.productDetailEl?.addEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.addEventListener('submit', this._onFormLoadingChange);
      document.addEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._syncTopHeight);
      this.bindTopHeightObserver();
      this.handleScroll();
      this.syncQuantityFromForm();
    }

    disconnectedCallback() {
      this.querySelectorAll('.lx-product-sticky-banner__tab[data-target]').forEach((tab) => {
        tab.removeEventListener('click', this._onTabClick);
      });

      this.addToCartBtn?.removeEventListener('click', this._onAddToCartClick);
      this.unbindQuantityListeners();

      this.productDetailEl?.removeEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );

      //   this.productFormEl?.removeEventListener('submit', this._onFormLoadingChange);
      document.removeEventListener('lx-add-to-cart:finished', this._onFormLoadingChange);

      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._syncTopHeight);
      this.unbindTopHeightObserver();
      this.setHeaderHidden(false);
    }

    bindTopHeightObserver() {
      this.unbindTopHeightObserver();
      this.topEl = this.querySelector('.lx-product-sticky-banner__top');

      if (!this.topEl) {
        this.syncTopHeight();
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._topResizeObserver = new ResizeObserver(this._syncTopHeight);
        this._topResizeObserver.observe(this.topEl);
      }

      this.syncTopHeight();
    }

    unbindTopHeightObserver() {
      this._topResizeObserver?.disconnect();
      this._topResizeObserver = null;
    }

    syncTopHeight() {
      const topEl = this.querySelector('.lx-product-sticky-banner__top');
      const sectionEl = this.closest('.shopify-section.lx-product-sticky-banner');

      if (!topEl) {
        this.style.removeProperty('height');
        this.style.removeProperty('--lx-product-sticky-banner-top-height');
        sectionEl?.style.removeProperty('height');
        return;
      }

      const height = Math.ceil(topEl.getBoundingClientRect().height);
      if (height <= 0) return;

      const heightValue = `${height}px`;
      this.style.setProperty('--lx-product-sticky-banner-top-height', heightValue);
      this.style.height = heightValue;
      sectionEl?.style.setProperty('height', heightValue);
    }

    bindQuantityListeners() {
      this.unbindQuantityListeners();
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl?.addEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.addEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.addEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.addEventListener('input', this._onFormQuantityChange);
    }

    unbindQuantityListeners() {
      this.bannerQuantityEl?.removeEventListener('change', this._onBannerQuantityChange);
      this.bannerQuantityEl?.removeEventListener('input', this._onBannerQuantityChange);
      this.formQuantityEl?.removeEventListener('change', this._onFormQuantityChange);
      this.formQuantityEl?.removeEventListener('input', this._onFormQuantityChange);
    }

    getScrollOffset() {
      return Number(this.dataset.scrollOffset || 32);
    }

    parseCssLength(value) {
      const num = parseFloat(String(value || '').trim());
      return Number.isFinite(num) ? num : 0;
    }

    getCssVar(name) {
      const bodyValue = getComputedStyle(document.body).getPropertyValue(name);
      if (bodyValue) return this.parseCssLength(bodyValue);

      return this.parseCssLength(getComputedStyle(document.documentElement).getPropertyValue(name));
    }

    getHeaderBarOffset() {
      // if (this._headerHidden) return 0;

      const barEl = document.querySelector('.shopify-section.alp-announcement-bar-section');
      const headerEl = document.querySelector('.shopify-section.alp-header-section');
      const barHeight = barEl?.offsetHeight || this.getCssVar('--bar-height');
      const headerHeight = headerEl?.offsetHeight || this.getCssVar('--header-height');

      return barHeight + headerHeight;
    }

    getHeaderOffset() {
      const bannerHeight =
        this.querySelector('.lx-product-sticky-banner__wrapper .lx-product-sticky-banner__top')?.offsetHeight || 0;
      return this.getHeaderBarOffset() + bannerHeight + this.getScrollOffset();
    }

    isBannerAtTop() {
      if (!this.classList.contains('is-visible')) return false;

      const topBar = this.querySelector('.lx-product-sticky-banner__top');
      if (!topBar) return false;

      const expectedTop = this.getHeaderBarOffset();
      const topBarTop = topBar.getBoundingClientRect().top;

      return topBarTop <= expectedTop + 8;
    }

    getHeaderElements() {
      return {
        bar: document.querySelector('.shopify-section.alp-announcement-bar-section'),
        header: document.querySelector('.shopify-section.alp-header-section'),
        section: document.querySelector('.shopify-section.lx-product-sticky-banner'),
      };
    }

    setHeaderHidden(hidden) {
      const nextHidden = Boolean(hidden);
      if (this._headerHidden === nextHidden) return;

      this._headerHidden = nextHidden;
      this.classList.toggle('is-header-hidden', nextHidden);
      document.documentElement.classList.add('lx-sticky-banner-header-transition');
      document.documentElement.classList.toggle('lx-sticky-banner-header-hidden', nextHidden);

      const { bar, header, section } = this.getHeaderElements();

      if (nextHidden) {
        // bar?.style.setProperty('opacity', '0');
        // bar?.style.setProperty('pointer-events', 'none');
        // header?.style.setProperty('opacity', '0');
        // header?.style.setProperty('pointer-events', 'none');
        // section?.style.setProperty('top', '0');
      } else {
        // bar?.style.removeProperty('opacity');
        // bar?.style.removeProperty('pointer-events');
        // header?.style.removeProperty('opacity');
        // header?.style.removeProperty('pointer-events');
        section?.style.removeProperty('top');
      }
    }

    updateHeaderOnScrollDirection() {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollDelta = currentScrollY - this._lastScrollY;

      if (!this.classList.contains('is-visible')) {
        this.setHeaderHidden(false);
        this._lastScrollY = currentScrollY;
        return;
      }

      if (!this.isBannerAtTop()) {
        if (scrollDelta < -4) {
          this.setHeaderHidden(false);
        }
        this._lastScrollY = currentScrollY;
        return;
      }

      if (scrollDelta > 4) {
        this.setHeaderHidden(true);
      } else if (scrollDelta < -4) {
        this.setHeaderHidden(false);
      }

      this._lastScrollY = currentScrollY;
    }

    handleScroll() {
      const productDetail = this.productDetailEl || document.querySelector('[data-product-detail]');
      const mainContent = document.querySelector('main#MainContent');

      if (!productDetail || !mainContent) {
        this.classList.remove('is-visible');
        this.setHeaderHidden(false);
        return;
      }

      const productTop = productDetail.offsetTop + productDetail.offsetHeight;
      const mainBottom = mainContent.offsetTop + mainContent.offsetHeight;
      const shouldShow = window.scrollY > productTop + 0 && window.scrollY < mainBottom - 80;
      const shouldShowBottom = window.scrollY > productTop && window.scrollY < mainBottom - 20;

      this.classList.toggle('is-visible', shouldShow);
      this.classList.toggle('is-visible-bottom', shouldShowBottom);

      if (!shouldShow) {
        this.setHeaderHidden(false);
      }

      this.updateHeaderOnScrollDirection();
      this.updateActiveTab();
    }

    resolveTargetElement(tab) {
      const selector = tab?.dataset?.target;
      const targetId = tab?.dataset?.targetId;

      if (selector) {
        const bySelector = document.querySelector(selector);
        if (bySelector) return bySelector;
      }

      if (targetId) {
        const byHandle = document.querySelector(`[data-section-handle="${targetId}"]`);
        if (byHandle) return byHandle;

        if (window.CSS?.escape) {
          return document.querySelector(`#${CSS.escape(targetId)}`);
        }

        return document.getElementById(targetId);
      }

      return null;
    }

    getTargetTop(targetEl) {
      return targetEl.getBoundingClientRect().top + window.scrollY;
    }

    updateActiveTab() {
      const tabs = [
        ...this.querySelectorAll(
          '.lx-product-sticky-banner__tab[data-target], .lx-product-sticky-banner__tab[data-target-id]'
        ),
      ];
      if (!tabs.length) return;

      const scrollLine = window.scrollY + this.getHeaderOffset();
      let activeTab = null;

      const entries = tabs
        .map((tab) => {
          const targetEl = this.resolveTargetElement(tab);
          if (!targetEl) return null;
          return { tab, top: this.getTargetTop(targetEl) };
        })
        .filter(Boolean)
        .sort((a, b) => a.top - b.top);

      for (const entry of entries) {
        if (scrollLine >= entry.top) {
          activeTab = entry.tab;
        }
      }

      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab === activeTab);
      });
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const targetEl = this.resolveTargetElement(tab);
      if (!targetEl) return;

      this.querySelectorAll('.lx-product-sticky-banner__tab').forEach((item) => {
        item.classList.toggle('is-active', item === tab);
      });

      const targetTop = this.getTargetTop(targetEl) - this.getHeaderOffset() + 2;
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
    }

    handleBannerQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityToForm();
    }

    handleFormQuantityChange() {
      if (this._syncingQuantity) return;
      this.syncQuantityFromForm();
    }

    syncQuantityFromForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;

      this.copyQuantityRules(this.formQuantityEl, this.bannerQuantityEl);

      if (this.formQuantityEl.value !== this.bannerQuantityEl.value) {
        this._syncingQuantity = true;
        this.bannerQuantityEl.value = this.formQuantityEl.value;
        this._syncingQuantity = false;
      }

      this.bannerQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncQuantityToForm() {
      this.formQuantityEl = this.productFormEl?.querySelector('lx-quantity-input [name="quantity"]');
      this.bannerQuantityEl = this.querySelector('[data-product-sticky-banner-element="quantity"] [name="quantity"]');

      if (!this.formQuantityEl || !this.bannerQuantityEl) return;
      if (this.formQuantityEl.value === this.bannerQuantityEl.value) return;

      this._syncingQuantity = true;
      this.formQuantityEl.value = this.bannerQuantityEl.value;
      this.formQuantityEl.dispatchEvent(new Event('change', { bubbles: true }));
      this._syncingQuantity = false;
    }

    copyQuantityRules(fromInput, toInput) {
      ['min', 'max', 'step', 'data-lx-qty-min', 'data-lx-qty-max', 'data-lx-qty-step'].forEach((attr) => {
        if (fromInput.hasAttribute(attr)) {
          toInput.setAttribute(attr, fromInput.getAttribute(attr));
        } else {
          toInput.removeAttribute(attr);
        }
      });
    }

    handleAddToCartClick() {
      if (!this.productFormEl || this.addToCartBtn?.disabled) return;

      this.syncQuantityToForm();
      this.addToCartBtn?.classList.add('is-loading');

      const submitButton = this.productFormEl.querySelector('[data-lx-add-to-cart-button], [type="submit"]');
      submitButton?.click();
    }

    handleFormLoadingChange() {
      setTimeout(() => {
        const isLoading = this.productFormEl?.classList.contains('loading');
        if (!isLoading) {
          this.addToCartBtn?.classList.remove('is-loading');
        }
      }, 200);
    }

    handleProductDetailUpdated(event) {
      const { html, variant } = event.detail || {};
      const sectionRoot = this.closest('[data-stid]');
      const sectionId = sectionRoot?.dataset?.stid;

      let nextBanner = null;
      if (sectionId && html) {
        nextBanner =
          html.querySelector(`[data-stid="${sectionId}"] lx-product-sticky-banner`) ||
          html.querySelector(`[data-stid="${sectionId}"] .lx-product-sticky-banner`);
      }
      nextBanner = nextBanner || html?.querySelector('lx-product-sticky-banner');

      if (nextBanner) {
        this.replaceElement('[data-product-sticky-banner-element="image"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="variant-title"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="price"]', nextBanner);
        this.replaceElement('[data-product-sticky-banner-element="quantity"]', nextBanner);
      } else if (variant) {
        this.updatePrice(variant);
        this.updateVariantTitle(variant);
      }

      if (variant) {
        this.dataset.variantId = String(variant.id);
        this.dataset.variantAvailable = String(variant.available);
        this.updateAddButton(variant);
        this.updateVariantTitle(variant);
      } else {
        this.updateAddButton(null);
      }

      this.bindQuantityListeners();
      this.syncQuantityFromForm();
    }

    replaceElement(selector, sourceRoot) {
      const currentEl = this.querySelector(selector);
      const nextEl = sourceRoot.querySelector(selector);
      if (!currentEl) return;

      if (!nextEl) {
        if (selector.includes('variant-title')) {
          currentEl.classList.add('hidden');
          currentEl.textContent = '';
        }
        return;
      }

      currentEl.innerHTML = nextEl.innerHTML;
      currentEl.className = nextEl.className;
    }

    updatePrice(variant) {
      const priceEl = this.querySelector('[data-product-sticky-banner-element="price"]');
      if (!priceEl || !variant) return;

      const currency = Shopify.currency.active;
      const language = `${Shopify.locale}-${Shopify.country}`;

      const priceNode = priceEl.querySelector('[data-product-price]');
      const compareNode = priceEl.querySelector('[data-product-compare-price]');

      if (priceNode && variant.price != null) {
        priceNode.textContent = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency,
        });
        priceNode.classList.toggle(
          'lx-product-sticky-banner__price-value--sale',
          variant.compare_at_price > variant.price
        );
      }

      if (compareNode) {
        if (variant.compare_at_price > variant.price) {
          compareNode.textContent = (variant.compare_at_price / 100).toLocaleString(language, {
            style: 'currency',
            currency,
          });
          compareNode.classList.remove('hidden');
        } else {
          compareNode.classList.add('hidden');
        }
      }
    }

    updateVariantTitle(variant) {
      const variantTitleEl = this.querySelector('[data-product-sticky-banner-element="variant-title"]');
      if (!variantTitleEl) return;

      const title = variant?.title?.trim();
      if (!title || title === 'Default Title') {
        variantTitleEl.classList.add('hidden');
        variantTitleEl.textContent = '';
        return;
      }

      variantTitleEl.textContent = title;
      variantTitleEl.classList.remove('hidden');
    }

    updateAddButton(variant) {
      const textEl = this.addToCartBtn?.querySelector('.lx-product-sticky-banner__add-to-cart-text');
      const available = Boolean(variant?.available);

      if (!this.addToCartBtn) return;

      this.addToCartBtn.disabled = !available;
      if (available) {
        this.addToCartBtn.removeAttribute('aria-disabled');
      } else {
        this.addToCartBtn.setAttribute('aria-disabled', 'true');
      }

      if (textEl) {
        textEl.textContent = available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
    }
  }

  if (!customElements.get('lx-product-sticky-banner')) {
    customElements.define('lx-product-sticky-banner', LXProductStickyBanner);
  }

  } catch(e) { console.error(e); }
})();
})();
